import { api, HttpClient, API_BASE_URL } from "../http"
import type {
  DeclarationSubmitRequest,
  DeclarationSubmitResponse,
  ThdfResponse,
  ThdfListItem,
  ThdfListParams,
  Page,
} from "../types";
 

const qs = (params: Record<string, unknown>) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "" && v !== "All")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join("&");

// QR verification must contact the server rather than falling back to offline records.
const qrClient = new HttpClient(API_BASE_URL, () => localStorage.getItem("auth_token"));

export const thdfApi = {
  getForQr(id: string) {
    return qrClient.request<ThdfResponse>(`/api/traveller/thdf/${encodeURIComponent(id)}`, { method: "GET", cache: "no-store" });
  },
  get(id: string) {
    return api.get<ThdfResponse>(`/api/traveller/thdf/${id}`);
  },
  submit(id: string, body: DeclarationSubmitRequest) {
    return api.put<DeclarationSubmitResponse, DeclarationSubmitRequest>(`/api/traveller/thdf/${id}`, body);
  },
  listByTraveller(travellerId: string, page = 0, size = 20) {
    return api.get<{ content: ThdfResponse[]; totalElements: number }>(
      `/api/traveller/thdf?travellerId=${encodeURIComponent(travellerId)}&page=${page}&size=${size}`
    );
  },
  delete(id: string) {
    return api.delete<null>(`/api/traveller/thdf/${id}`);
  },
  list(params: ThdfListParams = {}) {
    const query = qs(params as Record<string, unknown>);
    return api.get<Page<ThdfListItem>>(`/api/traveller/thdf${query ? `?${query}` : ""}`);
  },
  remove(id: string) {
    return api.delete<void>(`/api/traveller/thdf/${id}`);
  },
  exportCsvUrl(params: ThdfListParams = {}) {
    const query = qs(params);
    return `/api/traveller/thdf/export${query ? `?${query}` : ""}`;
  },
};
